// extracted by mini-css-extract-plugin
export default {"matchPreference":"matched_preference___matchPreference___cdec797f"};